export const init = () => {
  const components = document.querySelectorAll('.js-countdown');

  if (components.length === 0) return;

  components.forEach(component => {
    const timeArray = component.dataset.expDate.split(',').map(Number);
    timeArray[1] = timeArray[1] - 1;
    const expDate = new Date(Date.UTC(...timeArray));

    const updateCountdown = () => {
      const now = new Date();
      const distance = expDate - now;

      if (distance <= 0) {
        clearInterval(interval);
        component.querySelector('.js-countdown-days').innerHTML = '0';
        component.querySelector('.js-countdown-hours').innerHTML = '0';
        component.querySelector('.js-countdown-minutes').innerHTML = '0';
        if (component.querySelector('.js-countdown-seconds')) component.querySelector('.js-countdown-seconds').innerHTML = '0'
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);


      component.querySelector('.js-countdown-days').innerHTML = days;
      component.querySelector('.js-countdown-hours').innerHTML = hours;
      component.querySelector('.js-countdown-minutes').innerHTML = minutes;
      if (component.querySelector('.js-countdown-seconds')) component.querySelector('.js-countdown-seconds').innerHTML = seconds;
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  });
};